import Container from "@/components/common/Container";
import Layout from "@/components/layout/Layout";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LIST_OF_PRIVACY_DATA, PRIVACY_DATA } from "const/privacy-policy";
import Link from "next/link";
import { useEffect, useState } from "react";
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const PrivacyPolicy = () => {
  const [topVisible, setTopVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setTopVisible(true);
    } else if (scrolled <= 300) {
      setTopVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
  }, []);

  return (
    <Layout
      canonicalLink="https://ultroneous.com/privacy-policy"
      description="You accepted our privacy policy before using this website or any of its information or materials."
      ogDescription="You accepted our privacy policy before using this website or any of its information or materials."
      ogTitle="Privacy Policy - ultroNeous Technologies"
      title="Privacy Policy - ultroNeous Technologies"
    >
      <div
        className={`fixed bottom-0 right-0 p-4 bg-primary-yellow w-12 h-12 flex justify-center items-center rounded-full mr-4 mb-4 cursor-pointer ${
          topVisible ? "opacity-100" : "opacity-0"
        }`}
        role="presentation"
        onClick={() => scrollToTop()}
      >
        <FontAwesomeIcon height="1rem" icon={faArrowUp} width="1rem" />
      </div>
      <Container
        large
        className="bg-header-background bg-cover bg-bottom-center bg-no-repeat text-left pt-60 md:pt-20 xl:pt-72"
      >
        <p className="text-xl md:text-2xl lg:text-xl font-medium text-primary-yellow mb-4">
          <span>Privacy Policy</span>
        </p>
        <h1 className="text-4xl leading-snug md:text-7xl font-bold text-white md:leading-tight">
          <span className="inline-block">Your privacy is important to us</span>
        </h1>
      </Container>
      <Container
        large
        className="pt-8 pb-28 md:pt-8 md:pb-12 xl:pb-24 text-justify text-base font-normal text-white bg-primary-black"
      >
        <p className="mb-4">
          <span>
            It is ultroNeous Technologies&apos; policy to respect your privacy
            regarding any information we may collect while operating our
            website. This Privacy Policy applies to ultroneous.com/
            (hereinafter, &quot;us&quot;, &quot;we&quot;, or
            &quot;ultroneous.com/&quot;). We respect your privacy and are
            committed to protecting personally identifiable information you may
            provide us through the Website. We have adopted this privacy policy
            (&quot;Privacy Policy&quot;) to explain what information may be
            collected on our Website, how we use this information, and under
            what circumstances we may disclose the information to third parties.
            This Privacy Policy applies only to information we collect through
            the Website and does not apply to our collection of information from
            other sources.
          </span>
        </p>
        <p className="mb-4">
          <span>
            This Privacy Policy, together with the Terms of service posted on
            our Website, set forth the general rules and policies governing your
            use(&apos;of&apos;) our Website. Depending on your activities when
            visiting our Website, you may be required to agree to additional
            terms of service.
          </span>
        </p>
        <div>
          <h3 className="mt-16 text-primary-black text-5xl font-bold mb-4 webkit-text-stroke-white">
            <span className="font-poppins">Contents</span>
          </h3>
          <p className="mb-8">
            <span>
              Click below to jump to any section of this privacy policy
            </span>
          </p>
          {LIST_OF_PRIVACY_DATA.map((value, index) => (
            <Link key={value.id} href={value.link}>
              <a
                className="block font-medium text-lg mb-4 cursor-pointer"
                role="presentation"
              >
                <span>
                  {index + 1}.{value.text}
                </span>
              </a>
            </Link>
          ))}
        </div>
        <div className="pt-24 pb-0">
          {PRIVACY_DATA.map((val, index) => (
            <section id={val.id} className="mb-14 scroll-m-24" key={val.id}>
              <h4 className="font-semibold text-3xl text-white mb-8 text-start xl:text-justify">
                <span>
                  {index + 1}.{val.title}
                </span>
              </h4>
              {val.description.map((item) => (
                <p className="text-base font-normal mb-4" key={item}>
                  <span>{item}</span>
                </p>
              ))}
            </section>
          ))}
          <section id="section-9" className='scroll-m-24'>
            <h4 className="font-semibold text-3xl text-white mb-8 text-start xl:text-justify">
              <span>9. Contact Information & Credit</span>
            </h4>
            <p className="text-base font-normal">
              <span>
                This privacy policy was created at privacyterms.io privacy
                policy generator. If you have any questions about our Privacy
                Policy, please contact us via&nbsp;
                <Link href="mailto:hello@ultroneous.com">
                  <a className="text-blue-500 hover:text-primary-yellow">
                    email
                  </a>
                </Link>
                .
              </span>
            </p>
          </section>
        </div>
      </Container>
    </Layout>
  );
};
export default PrivacyPolicy;
